
export default {
  props: {
    keyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      course: {},
      isFetching: true,
      mainVideo: '',
      loggedIn: false,
      memberStatus: '',
      youtubeId: false,
      preorder: false,
      priceInfo: {},
      plusNetworkId: false,
      altTitle: 'Guitar Lessons - TrueFire',
      altDescription: 'TrueFire has the best online guitar courses for beginners and guitarists of all skill levels.',
      storewidePromo: false
    };
  },
  computed: {
    coursePlayerCover() {
      let courseId = this.keyId.replace('c', '');
      return `https://df4emreqpcien.cloudfront.net/images/courses/${courseId}/169_1920.jpg?format=webp&width=950`
    },
    metaTitle() {
      return this.course.title && this.course.educator_name ? `${this.course.title} - ${this.course.educator_name} - Guitar Lessons` : this.altTitle;
    },
    metaDescription() {
      return this.course.short_description || this.altDescription;
    },
    canonicalUrl() {
      return this.course.canonical || 'https://truefire.com/online-guitar-lessons';
    },
    memberNeedsAccess() {
      return ['trial_expi', 'expired', 'aatv_trial', 'trial', 'bass'].includes(this.memberStatus);
    },
    showCoursePromo() {
      try {
        return !this.storewidePromo || (this.storewidePromo < this.course.active_promo.discount);
      } catch {
        return false;
      }
    }
  },
  head() {
    return {
      title: this.metaTitle,
      meta: [
        // Basic Meta Tags
        { hid: 'description', name: 'description', content: this.metaDescription },
        { hid: 'robots', name: 'robots', content: 'index,follow' },
        { hid: 'viewport', name: 'viewport', content: 'width=device-width, initial-scale=1' },
        // Open Graph Meta Tags
        { hid: 'og:title', property: 'og:title', content: this.metaTitle },
        { hid: 'og:description', property: 'og:description', content: this.metaDescription },
        { hid: 'og:image', property: 'og:image', content: this.coursePlayerCover },
        { hid: 'og:url', property: 'og:url', content: this.canonicalUrl },
        { hid: 'og:type', property: 'og:type', content: 'website' },
        // Twitter Card Meta Tags
        { hid: 'twitter:title', name: 'twitter:title', content: this.metaTitle },
        { hid: 'twitter:description', name: 'twitter:description', content: this.metaDescription },
        { hid: 'twitter:image', name: 'twitter:image', content: this.coursePlayerCover },
        { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
        { hid: 'twitter:site', name: 'twitter:site', content: '@TrueFire' } // Replace with your actual Twitter handle
      ],
      link: [
        { rel: 'canonical', href: this.canonicalUrl },
        { rel: 'preload', as: 'image', href: this.coursePlayerCover, fetchpriority: 'high' }
      ]
    };
  },
  methods: {
    updateVideo(newUrl) {
      if (process.client) {
        this.mainVideo = newUrl;
      }
    },
    async getMemberInfo() {
      try {
        const member = await this.$member.get(['memberusername', 'tfu_status']);
        if (member.memberusername) {
          this.loggedIn = true;
          this.memberStatus = member.tfu_status;
        } else this.memberStatus = `none`;
      } catch (error) {
        console.error("Failed to fetch member info:", error);
      }
    },
    jumpTo(elemRef) {
      if(this.$refs[elemRef]){
        const elem = this.$refs[elemRef];
        window.scrollTo({
          top: elem.offsetTop - 24,
          behavior: "smooth"
        });
      }
    }
  },
  async created() {
    this.plusNetworkId = await this.$configs.plusNetwork();
    console.log('plus network id', this.plusNetworkId)
    this.isFetching = true;
    try {
      const courseFields = ["id", "title", "short_description", "recommendations", "yotpo", "sales_score", "intro_video", "description", "videos", { "play_cover": { "art": "169_1920" } }, "table_of_contents", "free_lessons", "educator", "yotpo", "truefire_items", "educator_items", "includes", "release_date:unixtime", "tags", "favorite", "status", "watch_link", "owns", "canonical","active_promo", 'youtube_intro_link'];
      this.course = await this.$course.getCourseInfo(this.keyId.replace('c', ''), courseFields);
      this.course.educator_name = this.course.educator.name;
      this.mainVideo = this.course.intro_video;
      if (!this.plusNetworkId) {
        this.priceInfo = this.course.truefire_items && this.course.truefire_items.length ? this.course.truefire_items : [];
      }
      else {
        this.priceInfo = this.course.educator_items && this.course.educator_items.length ? this.course.educator_items : [];
      }
      this.preorder = this.course.status == 2 || this.course.status == 4
      if(this.preorder && this.course.youtube_intro_link){
        this.youtubeId = this.course.youtube_intro_link.substring(this.course.youtube_intro_link.indexOf('?v=') + 3)
      }

      /* fix instances like you\'re to you're */
      this.course.description = this.course.description ? this.course.description.replaceAll(/\\\'/g, "\'") : ''; 
    }
    catch(e) {
    }
    this.isFetching = false;
    await this.getMemberInfo();

    try {
      if (this.plusNetworkId) {
        const nav = await this.$configs.nav(`educator`);
        if (nav && nav.promo) this.storewidePromo = nav.promo.discount;
      }
    } catch(e) {
    }
  }
}
